import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "../modal";
import InputComponent from "../input";
import ButtonComponent from "../button";
import { useFormik } from "formik";
import { countryCodeBlockSchema } from "../../helpers/schemas";
import TextareaComponent from "../textarea";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { ActionsContainer, CheckboxWrapper, EmptyWrapper, FieldContainer, FiltersWrapper, Form, FormError, FormWrapper, TableWrapper, TabsWrapper } from "./add-update-country-code-block-modal.style";
import FiltersComponent from "../filters";
import { BlockListSvg, ReloadSvg, SearchSvg } from "../../assets/svgs";
import TableComponent from "../table";
import moment from "moment";
import EmptyModalComponent from "../empty-modal";
import TabsComponent from "../tabs";
import { createCountryCodeTabsConstant, createCountryCodeTabsOptions  } from "../../constants/app-constants";
import BadgeComponent from "../badge";
import SelectDropdownSecondaryComponent from "../select-dropdown-secondary";
import { getAllAvailableCountryCodeList } from "../../redux/slices/global-country-code-block-slice";
import { providerInstitutionConstant } from "../../constants/user-constants";
import flagSvgs from "../../helpers/importFlagSvgs";

const AddUpdateCountryCodeBlockModal = ({ data, close, label, handleFormSubmit, viewOnly, update, fromParticipantlevel, fromRemoveCountry, fromMakerChecker, slide }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { allAvailableCountryCodeList } = useSelector((state) => state.globalCountryCodeBlockReducer);

    // const notProvider = (user?.institution?.id !== providerInstitutionConstant?.id) && (!user?.superAdmin);
    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);
    const isChecker = location.pathname.includes('checker');
    const isDisabledAll = isChecker || viewOnly || fromRemoveCountry;

    const initialSearch = {
        //   isoAlpha2: "",
        // numericCode: "",
        name: "",
    };

    const initialStates = {
        search: initialSearch,
        filteredData: allAvailableCountryCodeList || [],
        selectedTab: fromMakerChecker ? createCountryCodeTabsConstant.selected : createCountryCodeTabsConstant.all,
    };
    
    const [states, setStates] = useState(initialStates);

     // Sort blocked items to top for 'all' tab
        const sortedFilteredData = (states.selectedTab === createCountryCodeTabsConstant.all)
            ? [...states.filteredData].sort((a, b) => {
                const aBlocked = a.isGloballyBlocked || a.isParticipantLevelBlocked;
                const bBlocked = b.isGloballyBlocked || b.isParticipantLevelBlocked;
                if (aBlocked === bBlocked) return 0;
                return aBlocked ? -1 : 1;
            })
            : states.filteredData;
    const [hasChanges, setHasChanges] = useState(false);

    const { handleChange, handleBlur, handleSubmit, validateForm, setFieldValue, values, touched, errors, dirty } = useFormik({
        initialValues: data,
        validationSchema: countryCodeBlockSchema({ fromParticipantlevel, fromMakerChecker }),
        onSubmit: fromMakerChecker ? () => { } : (payload) => {
            if (hasChanges) {
                const updatedCountries = payload.countries.map(({ isGloballyBlocked, isParticipantLevelBlocked, ...rest }) => rest);
                const updatedPayload = { ...payload, countries: updatedCountries };
                handleFormSubmit(updatedPayload);
            } else {
                toast.info('No changes found');
            }
        },
    });

    const isParticipantLevelCheck = (!fromParticipantlevel || (fromParticipantlevel && values?.institutionCode));

    const handleAcceptReject = async (isAccept) => {
        const formErrors = await validateForm();

        if (Object.keys(formErrors).length < 1) {
            const { reason, ...blockedCountryRequest } = values;
            const institutionsName = institutionsWithID?.find((e) => e?.value === values?.institutionCode)?.label;
            handleFormSubmit({
                isaccepted: isAccept,
                blockedCountryRequest: { ...blockedCountryRequest, institutionCode: fromParticipantlevel ? { id: values?.institutionCode, descr: institutionsName } : null },
                reason,
            });
        } else {
            handleSubmit();
        }
    };

    const handleChangeFilters = (e) => {
        const { name, value, type, checked } = e.target
        setStates((old) => ({
            ...old,
            search: ({
                ...old.search,
                [name]: ['checkbox', 'radio'].includes(type) ? checked : value
            })
        }));
    };

    const handleResetFilters = () => {
        setStates((old) => ({
            ...old,
            search: initialSearch,
            filteredData: allAvailableCountryCodeList || [],
        }));
    };

    const handleFiltersSubmit = (e) => {
        e.preventDefault();
        const { search } = states;
        const filteredData = allAvailableCountryCodeList?.filter((item) => {
            //   return (
            //     (search.isoAlpha2 ? item.isoAlpha2 === search.isoAlpha2 : true) &&
            //     (search.numericCode ? item.numericCode.toString().includes(search.numericCode.toString()) : true)
            // );
            // If a country is selected, show only that country
            if (search.name) {
                return item.name === search.name;
            }
            // Otherwise show all countries
            return true;
        });
        setStates((old) => ({
            ...old,
            filteredData: filteredData,
            selectedTab: createCountryCodeTabsConstant.all,
        }));
    };

     const handleSelectCountryCodes = (row) => {
        const isCountryExists = values?.countries?.some((country) => country?.isoAlpha2 === row?.isoAlpha2);
        const updatedCountryCodes = isCountryExists
            ? values.countries.filter((country) => country?.isoAlpha2 !== row?.isoAlpha2)
            : [...values.countries, row];
        setFieldValue('countries', updatedCountryCodes);
    };

    useEffect(() => {
        setHasChanges(dirty);
    }, [dirty]);

    useEffect(() => {
        if (fromParticipantlevel && values?.institutionCode && values?.institutionCode !== '') {
            dispatch(getAllAvailableCountryCodeList({ user, search: { institutionCode: values?.institutionCode } })).then((action) => {
                if ((action?.payload?.status === 201 || action?.payload?.status === 200) && !fromMakerChecker) {
                    setFieldValue('countries', []);
                }
            });
        }
    }, [values?.institutionCode]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (allAvailableCountryCodeList && allAvailableCountryCodeList.length > 0) {
            setStates((old) => ({
                ...old,
                filteredData: allAvailableCountryCodeList,
            }));
        }
    }, [allAvailableCountryCodeList]);

    const searchFields = [
        {
            label: 'Country Name',
            type: 'select',
            // style: { border: '1px solid grey'},
            options: (() => {
                // Keep all countries from API response as they are, just map to dropdown format
                // This preserves any legitimate duplicates from the API while ensuring we don't create extra ones
                return allAvailableCountryCodeList?.map((country, index) => {
                    let flagSrc = null;
                    try {
                        if (country.isoAlpha2) {
                            flagSrc = flagSvgs(`./${country.isoAlpha2?.toLowerCase()}.svg`);
                        }
                    } catch (error) {
                        // Flag not found, flagSrc remains null
                        console.warn(`Flag not found for country: ${country.name} (${country.isoAlpha2})`);
                    }
                    
                    return {
                        label: `${country.name} (${country.numericCode})`,
                        value: country.name,
                        flag: flagSrc,
                        isoAlpha2: country.isoAlpha2,
                        numericCode: country.numericCode,
                        // Add unique key to distinguish between identical entries
                        key: `${country.isoAlpha2}-${index}`
                    };
                }) || [];
            })(),
            name: 'name',
            value: states.search.name,
        },
        {
            type: 'action',
            actions: [
                { label: 'Reset', icon: ReloadSvg, type: 'button', outline: true, action: handleResetFilters },
                { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
            ],
        }
    ];

    const fields = [
        {
            label: 'Effective Date',
            type: 'datetime-local',
            placeholder: 'Set effective date',
            name: 'effectiveDate',
            value: values?.effectiveDate || '',
            min: moment().add(1, 'day').startOf('day').format().slice(0, 16),
            disabled: isDisabledAll,
        },
        ...(fromMakerChecker ? [{
            label: 'Comments',
            type: 'textarea',
            placeholder: 'Enter Comments',
            name: 'reason',
            value: values?.reason,
            fullCol: true,
        }] : []),
        {
            type: 'action',
            actions: fromMakerChecker ? [
                { label: 'Reject', type: 'button', color: 'error', outline: true, action: () => handleAcceptReject(false) },
                { label: isChecker ? 'Approve' : 'Resend', type: 'button', action: () => handleAcceptReject(true) }
            ] : [
                { label: viewOnly ? 'Close' : 'Cancel', type: 'button', outline: !viewOnly, action: close },
                ...(!viewOnly ? [{ label: update ? 'Update' : 'Block', type: 'submit' }] : [])
            ],
            fullCol: true,
        }
    ];

    // TABLE COLUMNS SETUP AS PER DATA
    const columns = [
        {
            field: 'action',
            headerName: 'Action',
            width: 60,
            align: 'center',
            valueGetter: (row) => {
                return (
                    <CheckboxWrapper>
                        <input
                            type='checkbox'
                            checked={row?.isGloballyBlocked || row?.isParticipantLevelBlocked || values?.countries?.some((country) => country?.isoAlpha2 === row?.isoAlpha2)}
                            onChange={() => handleSelectCountryCodes(row)}
                            disabled={isDisabledAll || row?.isGloballyBlocked || row?.isParticipantLevelBlocked}
                        />
                    </CheckboxWrapper>
                )
            },
            sortBy: (row) => ((row?.isGloballyBlocked || row?.isParticipantLevelBlocked || values?.countries?.some((country) => country?.isoAlpha2 === row?.isoAlpha2)) ? 1 : 0),
        },
        ...((states.filteredData.some(item => item?.isGloballyBlocked === true || item?.isParticipantLevelBlocked === true) && states.selectedTab === createCountryCodeTabsConstant.all) ? [{
            field: 'status',
            headerName: 'Status',
            width: 120,
            align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.isGloballyBlocked ? (
                                <BadgeComponent label={`${fromParticipantlevel ? 'Globally' : ''} Blocked`} type="error" outline />
                            ) : (fromParticipantlevel && row?.isParticipantLevelBlocked) ? (
                                <BadgeComponent label="Blocked" type="error" />
                            ) : '—'
                        }
                    </>
                )
            },
            sortBy: (row) => (row?.isGloballyBlocked ? 1 : row?.isParticipantLevelBlocked ? 0 : -1),
        }] : []),
        {
            field: 'flag',
            headerName: 'Flag',
            width: 60,
            align: 'center',
            valueGetter: (row) => {
                try {
                    if (row?.isoAlpha2) {
                        const flagSrc = flagSvgs(`./${row.isoAlpha2.toLowerCase()}.svg`);
                        return <img src={flagSrc} alt={row.name} style={{ border: '1px solid var(--border-color)', width: '35px', height: 'auto', objectFit: 'cover' }} />;
                    }
                } catch (error) {
                    // Flag not found, show fallback
                    // console.warn(`Flag not found for country: ${row.name} (${row.isoAlpha2})`);
                }
                return '—';
            },
            sortBy: (row) => row?.isoAlpha2,
        },
        { field: 'name', headerName: 'Country Name', width: 100, align: 'center' },
        { field: 'numericCode', headerName: 'Numeric Code', width: 100, align: 'center' },
        { field: 'isoAlpha3', headerName: 'Country Code ISO', width: 100, align: 'center' },
    ];

    return (
        <ModalComponent close={close} label={label} width={1000} slide={slide}>
            {/* MODAL BODY */}
            <FormWrapper>
                {/* INSTITUTION SELECTOR */}
                {
                    fromParticipantlevel &&
                    <FieldContainer>
                        {/* <Label>Institution</Label> */}
                        <SelectDropdownSecondaryComponent
                            label="Institution"
                            options={institutionsWithID}
                            name="institutionCode"
                            value={values.institutionCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isDisabledAll || update || !isProvider}
                            mui
                        />
                        {
                            touched.institutionCode && errors.institutionCode && (
                                <FormError>{errors.institutionCode}</FormError>
                            )
                        }
                    </FieldContainer>
                }

                {
                    !isParticipantLevelCheck &&
                    <EmptyWrapper>
                        <EmptyModalComponent text={isDisabledAll ? 'No country codes found!' : 'Please select institution first!'} />
                    </EmptyWrapper>
                }

                {/* FILTER */}
                {
                    (searchFields && searchFields.length > 0 && !isChecker) && isParticipantLevelCheck && !fromRemoveCountry && (
                        <FiltersWrapper>
                            <label>Filters</label>
                            <FiltersComponent open={true} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} cols={3} />
                        </FiltersWrapper>
                    )
                }

                {/* TABLE & EFFECTIVE DATE */}
                <Form onSubmit={handleSubmit}>
                    {
                        isParticipantLevelCheck && !fromRemoveCountry && (
                            <TabsWrapper>
                                <TabsComponent
                                    tabs={
                                        createCountryCodeTabsOptions.map((tab) => ({
                                            label: tab.label,
                                            value: tab.value,
                                            count: tab.value === createCountryCodeTabsConstant.all ? states.filteredData?.length : tab.value === createCountryCodeTabsConstant.selected ? values?.countries?.length : undefined,
                                        }))
                                    }
                                    value={states.selectedTab}
                                    onChange={(value) => setStates((old) => ({ ...old, selectedTab: value }))}
                                >
                                    {
                                        states.selectedTab === createCountryCodeTabsConstant.all && (
                                            <TableWrapper>
                                                {
                                                    sortedFilteredData && sortedFilteredData.length > 0 ? (
                                                    // states.filteredData && states.filteredData.length > 0 ? 
                                                        <>
                                                            <TableComponent rows={sortedFilteredData} columns={columns} icon={BlockListSvg} responsive={false} />
                                                            {
                                                                touched?.countries && errors?.countries && (
                                                                    <FormError>{errors?.countries}</FormError>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                        <EmptyWrapper>
                                                            <EmptyModalComponent text={isDisabledAll ? 'No Countries found!' : 'Need to filter by Countries group first or No Countries found!'} />
                                                            {
                                                                touched?.countries && errors?.countries && (
                                                                    <FormError>{errors?.countries}</FormError>
                                                                )
                                                            }
                                                        </EmptyWrapper>
                                                    )
                                                }
                                            </TableWrapper>
                                        )
                                    }
                                    {
                                        states.selectedTab === createCountryCodeTabsConstant.selected && (
                                            <TableWrapper>
                                                {
                                                    values?.countries && values?.countries.length > 0 ? (
                                                        <>
                                                            <TableComponent rows={values?.countries} columns={columns} icon={BlockListSvg} />
                                                            {
                                                                touched?.countries && errors?.countries && (
                                                                    <FormError>{errors?.countries}</FormError>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                        <EmptyWrapper>
                                                            <EmptyModalComponent text='No Countries Selected!' />
                                                            {
                                                                touched?.countries && errors?.countries && (
                                                                    <FormError>{errors?.countries}</FormError>
                                                                )
                                                            }
                                                        </EmptyWrapper>
                                                    )
                                                }
                                            </TableWrapper>
                                        )
                                    }
                                </TabsComponent>
                            </TabsWrapper>
                        )
                    }

                    {
                        fromRemoveCountry &&
                        <TableWrapper>
                            <TableComponent rows={values?.countries} columns={columns} icon={BlockListSvg} />
                        </TableWrapper>
                    }

                    {
                        fields && fields.length > 0 && fields.map((field, index) => (
                            <Fragment key={index}>
                                {
                                    ['text', 'number', 'datetime-local'].includes(field.type) && !field.hide && isParticipantLevelCheck &&
                                    <FieldContainer $fullcol={field.fullCol}>
                                        {/* <Label>{field.label}</Label> */}
                                        <InputComponent
                                            type={field.type}
                                            label={field.label}
                                            placeholder={field.placeholder}
                                            onBlur={handleBlur}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            min={field.min}
                                            disabled={field.disabled}
                                            mui
                                        />
                                        {
                                            touched[field.name] && errors[field.name] && (
                                                <FormError>{errors[field.name]}</FormError>
                                            )
                                        }
                                    </FieldContainer>
                                }

                                {
                                    field.type === 'textarea' && !field.hide &&
                                    <FieldContainer $fullcol={field.fullCol}>
                                        {/* <Label>Comments</Label> */}
                                        <TextareaComponent
                                            label="Comments"
                                            placeholder={field.placeholder}
                                            onBlur={handleBlur}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            disabled={field.disabled}
                                            mui
                                        />
                                        {
                                            touched[field.name] && errors[field.name] && (
                                                <FormError>{errors[field.name]}</FormError>
                                            )
                                        }
                                    </FieldContainer>
                                }

                                {
                                    field.type === 'action' && field.actions.length > 0 &&
                                    <FieldContainer $fullcol={field.fullCol}>
                                        <ActionsContainer>
                                            {
                                                field.actions.map((button, index) => (
                                                    <ButtonComponent key={index} label={button.label} type={button.type} outline={button.outline} color={button.color} onClick={button.action} />
                                                ))
                                            }
                                        </ActionsContainer>
                                    </FieldContainer>
                                }
                            </Fragment>
                        ))
                    }
                </Form>
            </FormWrapper>
        </ModalComponent>
    );
};

export default AddUpdateCountryCodeBlockModal;